import { CardVariant } from "../../models/CardVariant"
import { classNamesOrEmpty } from "../../style/common";

export type CardVariantImagePlaceholderOverlayProps = {
    variant: CardVariant,
    className?: string | undefined
}

export function CardVariantImagePlaceholderOverlay(props: CardVariantImagePlaceholderOverlayProps) {
    if (!props.variant.isTempImage) {
        return <></>;
    }
    
    return (
        <span
            className={`absolute w-full font-bold ${classNamesOrEmpty(props.className)}`}>
            <svg
                width="100%"
                height="100%"
                viewBox="0 0 858 1200"
                preserveAspectRatio="xMinYMid meet"
                xmlns="http://www.w3.org/2000/svg"
            >
                <text
                    x="90"
                    y="450"
                    fontSize="75"
                    fill="white"
                    style={{ filter: "drop-shadow(3px 5px 2px black)" }}
                >Placeholder Image</text>
            </svg>
        </span>
    )
}